import { computed } from 'vue'
import addTargetBlankToLinks from '@/composables/addTargetBlankToLinks'

export default {
    name: 'BlockParagraph',
    props: {
        paragraphObj: Object
    },
    setup(props) {
        const data = computed(() => props.paragraphObj.data.text)
        const { htmlTextWithTargetBlank } = addTargetBlankToLinks(data)
        return {
            htmlTextWithTargetBlank
        }
    }
}
